import LaptopIcon from './component.jsx'
export default LaptopIcon
